import React, { useState } from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import { Box, Button, Tabs, Tab } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import RuleIcon from '@mui/icons-material/Rule';
import DeviceSettingsComponent from '../components/devices/DeviceSettingsComponent';
import DeviceRulesComponent from '../components/devices/DeviceRulesComponent';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
};

const DeviceSettingsPage: React.FC = () => {
  const { id } = useParams();
  const [tabValue, setTabValue] = useState(0);

  if (!id) return null;

  return (
    <Box>
      <Button component={RouterLink} to={`/devices/${id}/events`} sx={{ mb: 2 }}>
        ← Back to Events
      </Button>
      
      <Tabs value={tabValue} onChange={(_, newValue) => setTabValue(newValue)} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tab icon={<SettingsIcon />} iconPosition="start" label="Device Settings" />
        <Tab icon={<RuleIcon />} iconPosition="start" label="Rules" />
      </Tabs>

      <TabPanel value={tabValue} index={0}>
        <DeviceSettingsComponent deviceId={id} />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <DeviceRulesComponent deviceId={id} />
      </TabPanel>
    </Box>
  );
};

export default DeviceSettingsPage;
